import { render, staticRenderFns } from "./TaskTypesInput.vue?vue&type=template&id=8843030e&scoped=true"
import script from "./TaskTypesInput.vue?vue&type=script&lang=ts"
export * from "./TaskTypesInput.vue?vue&type=script&lang=ts"
import style0 from "./TaskTypesInput.vue?vue&type=style&index=0&id=8843030e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8843030e",
  null
  
)

export default component.exports